import { InitSurveyResponseDTO } from '@/core/dto/psychosocial-report';
import type { InitSurveyResponse } from '@/types/Psychosocial';
import { I18n } from '@aws-amplify/core';

export class InitSurveyMapper {
	constructor(private readonly data: InitSurveyResponseDTO) {}

	private formatQuestionTitle(title: string, index: number, has_options: boolean): string {
		if (has_options) {
			return `${index + 1}. ${I18n.get(title)}`;
		}

		return I18n.get(title);
	}

	toDomain(): InitSurveyResponse {
		return {
			tool: {
				tool_name: this.data.tool.tool_name,
				tool_description: this.data.tool.tool_description
			},
			questions: this.data.questions.map((question, index) => ({
				id: question.id,
				title: this.formatQuestionTitle(question.title, index, (question?.options?.length ?? 0) > 0),
				description: question.description,
				options: question.options,
				category: question.category,
				order: index
			})),
			participation: {
				id: this.data.participation.id,
				employee_id: this.data.participation.employee_id,
				survey_id: this.data.participation.survey_id,
				updated_at: this.data.participation.updated_at,
				created_at: this.data.participation.created_at
			}
		};
	}
}
